module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gMCNW"))).then(() => parcelRequire('1iHdE'));